import * as d3 from 'd3';

import kernelDensityEstimator from './kernelDensityEstimator';
import kernelEpanechnikov from './kernelEpanechnikov';
// import displayBoxPlot from './displayBoxPlot';
import Quartile from './Quartile';
import Vue from 'vue';
import Array_Average from './Array_Average';
import Array_Stdev from './Array_Stdev';
import calculateKLDivergence from './KLDivergence';



const returnLowerAndUpperWhisker = (inputArray, q25Value, q75Value) => {

    /****************************
      Compute the whiskers
      --------------------
      The IQR (inter-quartile range) is Q3 - Q1.
      The upper fence is: (Q3 + 1.5*IQR)
      The lower fence is: (Q1 - 1.5*IQR)

      The lower whisker is now: the smallest value still greater than or equal to the lower fence
      The upper wisker is now: the maximum value that is below or equal to the upper fence
    *****************************/

    // Clone the array and sort
    let sortedArray = [...inputArray].sort(function(a,b){return a - b})
    // console.log(sortedArray)

    let iqr = q75Value - q25Value;

    let iqr_factor = 1.5;

    let upperWhisker;
    let lowerWhisker;

    let lowerFence = q25Value - iqr_factor * iqr;
    let upperFence = q75Value + iqr_factor * iqr;

    // Determine upperWhisker
    for (let i = 0; i < sortedArray.length; i++){
      if (sortedArray[i] <= upperFence){
        upperWhisker = sortedArray[i]
      } else {
        break;
      }
    }

    // Determine lowerWhisker
    for (let i = sortedArray.length -1; i >= 0; i--){
      // console.log(sortedArray[i])
      if (sortedArray[i] >= lowerFence){
        lowerWhisker = sortedArray[i]
      } else {
        break;
      }
    }

    let result = [lowerWhisker, upperWhisker];

    return result;

}


const plotDetailPopUpGraph = (matrix, givenName, lowerBound, upperBound, idOfEmittingNode, uidOfEmittingVueDistPreview = undefined) => {
  /* 
    This function takes the following parameters:
    (1) the matrix of data; this can be arrayvalues or the temp highlighted values
    (2) the name of the node that "emitted" this pop-up. This way, the title of the pop-up can be the same as the node's name.
    A third parameter is obtained as a global variable: the globalHighlightArray
    
    The matrix that is passed into this function is an array of arrays.
    The first dimension is the number of periods for which the data was generated.
    Each of these period-specific arrays is a list of samples.
    The number of samples is identical and depends on the 'sampling number' set in the menu bar.
  */


  // make a clone of that matrix
  // this unaltered clone is sent to the boxplot function
  let matrixClone = matrix.map(function(arr) {
    return arr.slice();
  });

    // make a clone of that matrix
  // this unaltered clone is sent to the download function
  let matrixCloneForDownload = matrix.map(function(arr) {
    return arr.slice();
  });

  // Get the selected time slice from the global variable
  let selectedTimeSlice = Vue.prototype.$globalSharedData.selectedPeriod;

  // This is passed onto the popup vue for download
  let distValuesForSelectedTimeSlice = [...matrixClone[selectedTimeSlice]]; // make a clone of that array

  // Here we create a single array that is the total across all time periods / slices
  // Since we are dealing with samples, we just add up the i-th element across all periods
  // TODO: sum function could be simplified using map()
  // We assume here that all arrays MUST have the same length (which should be the case)
  let valTotals = [];
  for( var j = 0; j < matrix[0].length; j++){
    // Iterate over all elements in the period-specific array (e.g. 10000 values)
    let element_sum = 0;
    for( var i = 0; i < matrix.length; i++){
      // Iterate over the periods (matrix.length is the number of periods)
      element_sum += matrix[i][j]
      //console.log('Adding ' + matrix[i][j] + ' to element ' + j + ' in period ' + i);
    }
    valTotals.push(element_sum);
  }
  

  let val = [...matrixClone[selectedTimeSlice]]; // make a clone of that array
  let minDataPoint = d3.min(val);
  let maxDataPoint = d3.max(val);

  
  // set the dimensions and margins of the graph
  let margin = {top: 10, right: 30, bottom: 30, left: 50},
    width = 500 - margin.left - margin.right,
    height = 350 - margin.top - margin.bottom;

  // add the x Axis
  // Is is defined here to have x.ticks available below
  // It gets redefined again below
  let x = d3.scaleLinear()
    .domain([minDataPoint,maxDataPoint])
    .range([0, width]);

  let reducedValueArray = [];
  for (let i = 0; i < val.length; i++) {
    if(Vue.prototype.$globalHighlightArray[i]==1){
      reducedValueArray.push(val[i]);
    }
  }

  /************************************************************** 
    Calculate how many data points are within highlight range
  ***************************************************************/

  let countOfDataPointsWithinRange = 0;
  // console.log('lowerBound', lowerBound)
  // console.log('upperBound', upperBound)

  // val is the 1-dim array of data for the selected time slice only

  if ((typeof lowerBound == 'undefined') || (typeof upperBound == 'undefined')){
    // this is the case if the node just got opened
    // use the last variable values stored as global variables instead
    let oldLowerBound = parseFloat(Vue.prototype.$globalSharedData.lastSliderPositionLowerBoundAsString);
    let oldUpperBound = parseFloat(Vue.prototype.$globalSharedData.lastSliderPositionUpperBoundAsString);

    if (oldLowerBound < oldUpperBound){
      for (let j = 0; j < val.length; j++){      
        if ((val[j] >= oldLowerBound) && (val[j] <= oldUpperBound)){
          countOfDataPointsWithinRange += 1;
        }
      }
    } else {
      // old lowerBound is larger than old upperBound
      for (let j = 0; j < val.length; j++){
        // in this case, we take all values larger than lowerBound or lower than upperBound
        if ((val[j] >= oldLowerBound) || (val[j] <= oldUpperBound)){
          countOfDataPointsWithinRange += 1;
        }
      }
    }
  } else if (lowerBound < upperBound){
    for (let j = 0; j < val.length; j++){      
      if ((val[j] >= lowerBound) && (val[j] <= upperBound)){
        countOfDataPointsWithinRange += 1;
      }
    }
  } else {
    // lowerBound is larger than upperBound
    for (let j = 0; j < val.length; j++){
      // in this case, we take all values larger than lowerBound or lower than upperBound
      if ((val[j] >= lowerBound) || (val[j] <= upperBound)){
        countOfDataPointsWithinRange += 1;
      }
    }
  }

  let shareOfDataPointsWithinRange = countOfDataPointsWithinRange / val.length;

  
  /************************************* 
    Compute kernel density estimation 
  *************************************/

  let kde = kernelDensityEstimator(kernelEpanechnikov((maxDataPoint-minDataPoint)/15), x.ticks(40))
  let density =  kde(val)
  let densityHighlight =  kde(reducedValueArray);


  let xDensity = density.map(function(elt) { return elt[0]; });
  let yDensity = density.map(function(elt) { return elt[1]; });

  let xDensityMax = d3.max(xDensity);
  let xDensityMin = d3.min(xDensity);

  density.unshift([xDensityMin-Math.abs(xDensityMax-xDensityMin)*0.01,0])
  density.unshift([xDensityMin-Math.abs(xDensityMax-xDensityMin)*0.2,0])
  density.push([xDensityMax+Math.abs(xDensityMax-xDensityMin)*0.01,0])
  density.push([xDensityMax+Math.abs(xDensityMax-xDensityMin)*0.2,0])

  let minDensityXValueIncludingAddedOnes = density[0][0]; // get the first datapoint we added
  let maxDensityXValueIncludingAddedOnes = density[density.length -1][0]; // get the last datapoint we added

   
 
 
	/****************************************************
    x axis
    Careful: The variable was already declared above
	****************************************************/
    
  x = d3.scaleLinear()
    .domain([xDensityMin-Math.abs(xDensityMax-xDensityMin)*0.2, xDensityMax+Math.abs(xDensityMax-xDensityMin)*0.2])
    .range([0, width]);
      
    
	/***************************************
		Highlight curve
	***************************************/    
  
  // The following functions just create an array of the first elements, or second elements (from the array of arrays)
  let xDensityHighlight = densityHighlight.map(function(elt) { return elt[0]; });
  let yDensityHighlight = densityHighlight.map(function(elt) { return elt[1]; });

  let xDensityHighlightMax = d3.max(xDensityHighlight);
  let xDensityHighlightMin = d3.min(xDensityHighlight);

  densityHighlight.unshift([xDensityHighlightMin-Math.abs(xDensityHighlightMax-xDensityHighlightMin)*0.01,0])
  densityHighlight.unshift([xDensityHighlightMin-Math.abs(xDensityHighlightMax-xDensityHighlightMin)*0.2,0])
  densityHighlight.push([xDensityHighlightMax+Math.abs(xDensityHighlightMax-xDensityHighlightMin)*0.01,0])
  densityHighlight.push([xDensityHighlightMax+Math.abs(xDensityHighlightMax-xDensityHighlightMin)*0.2,0])
  
  let yHighlight = d3.scaleLinear()
      .range([height, 0])
      .domain([0, d3.max(yDensityHighlight)]);      

  let xHighlight = d3.scaleLinear()
      .domain([xDensityHighlightMin-Math.abs(xDensityHighlightMax-xDensityHighlightMin)*0.2, xDensityHighlightMax+Math.abs(xDensityHighlightMax-xDensityHighlightMin)*0.2])
      .range([0, width]);
  
  
  /*****************************************************
    Calculate statistics for the selected time slice for the normal value array
  ******************************************************/
  
  let arrayMedian = new Intl.NumberFormat('en-US', {maximumFractionDigits: 2}).format(Quartile(val, 0.5));
  let arrayQuartile25 = new Intl.NumberFormat('en-US', {maximumFractionDigits: 2}).format(Quartile(val, 0.25));
  let arrayQuartile75 = new Intl.NumberFormat('en-US', {maximumFractionDigits: 2}).format(Quartile(val, 0.75));
  
  let arrayMean = new Intl.NumberFormat('en-US', {maximumFractionDigits: 2}).format(Array_Average(val));
  let arrayStdev = new Intl.NumberFormat('en-US', {maximumFractionDigits: 2}).format(Array_Stdev(val));

  let arrayMin = Math.floor(Math.min(...val)*100)/100;
  let arrayMax = Math.ceil(Math.max(...val)*100)/100;


  /*****************************************************
  Calculate statistics for the selected time slice for the REDUCED! value array
  ******************************************************/
  let arrayMedianHighlight;
  let arrayQuartile25Highlight;
  let arrayQuartile75Highlight;
  let arrayMeanHighlight;
  let arrayStdevHighlight;

  if (reducedValueArray.length > 0){

    arrayMedianHighlight = new Intl.NumberFormat('en-US', {maximumFractionDigits: 2}).format(Quartile(reducedValueArray, 0.5));
    arrayQuartile25Highlight = new Intl.NumberFormat('en-US', {maximumFractionDigits: 2}).format(Quartile(reducedValueArray, 0.25));
    arrayQuartile75Highlight = new Intl.NumberFormat('en-US', {maximumFractionDigits: 2}).format(Quartile(reducedValueArray, 0.75));
    
    arrayMeanHighlight = new Intl.NumberFormat('en-US', {maximumFractionDigits: 2}).format(Array_Average(reducedValueArray));
    arrayStdevHighlight = new Intl.NumberFormat('en-US', {maximumFractionDigits: 2}).format(Array_Stdev(reducedValueArray));

  }

  /***********************************************************
    Calculate statistics for the sum of all time slice arrays
  ************************************************************/

  // let valTotalsMedian = new Intl.NumberFormat('en-US', {maximumFractionDigits: 2}).format(Quartile(valTotals, 0.5));
  // let valTotalsQuartile25 = new Intl.NumberFormat('en-US', {maximumFractionDigits: 2}).format(Quartile(valTotals, 0.25));
  // let valTotalsQuartile75 = new Intl.NumberFormat('en-US', {maximumFractionDigits: 2}).format(Quartile(valTotals, 0.75));
  
  // let valTotalsMean = new Intl.NumberFormat('en-US', {maximumFractionDigits: 2}).format(Array_Average(valTotals));
  // let valTotalsStdev = new Intl.NumberFormat('en-US', {maximumFractionDigits: 2}).format(Array_Stdev(valTotals));

  
  let valTotalsMedian = undefined;
  let valTotalsQuartile25 = undefined;
  let valTotalsQuartile75 = undefined;
  
  let valTotalsMean = undefined;
  let valTotalsStdev = undefined;

  // let valTotalsMin = Math.floor(Math.min(...val)*100)/100;
  // let valTotalsMax = Math.ceil(Math.max(...val)*100)/100;


  /* 
    Prepare an object with statistics for the normal array and the highlight array
  */

  let dataForComparisonOfDensitiesAsFormattedStrings = {

    original: {
      quartile25: arrayQuartile25,
      mean: arrayMean,
      median: arrayMedian,
      quartile75: arrayQuartile75,
      standarddeviation: arrayStdev,
    },
    highlight: {
      quartile25: arrayQuartile25Highlight,
      mean: arrayMeanHighlight,
      median: arrayMedianHighlight,
      quartile75: arrayQuartile75Highlight,
      standarddeviation: arrayStdevHighlight,
    }
  }


  /************************************************************************************ 
    Calculate the statistics for all time slices to be made available for download
    Note: This looks redundant to above but we need to return numbers here, not strings!
  ************************************************************************************/

  let statisticsForDownload = {

    // These arrays are for the values for each time slice!
    // That is why we cannot use val anymore!
    // By definition, the _last_ value in each array shall be for the sum of all periods

    mean: [],
    median: [],
    quartile75: [],
    quartile25: [],
    stdev: [],
    upperWhisker: [],
    lowerWhisker: []

  }

  for (let timeSlice = 0; timeSlice < matrixClone.length; timeSlice++){

    statisticsForDownload.mean.push(Array_Average(val));

    let q25 = Quartile(matrixClone[timeSlice], 0.25)
    let q75 = Quartile(matrixClone[timeSlice], 0.75)

    statisticsForDownload.median.push(Quartile(matrixClone[timeSlice], 0.5));
    statisticsForDownload.quartile25.push(q25);
    statisticsForDownload.quartile75.push(q75);

    let whiskers = returnLowerAndUpperWhisker(matrixClone[timeSlice], q25, q75);
    
    statisticsForDownload.lowerWhisker.push(whiskers[0]);
    statisticsForDownload.upperWhisker.push(whiskers[1]);

    
    statisticsForDownload.stdev.push(Array_Stdev(matrixClone[timeSlice]));

  }

  // Lastly, add the statistics for the sum of all timeSlice arrays
  statisticsForDownload.mean.push(Array_Average(valTotals));

  let q25Totals = Quartile(valTotals, 0.25)
  let q75Totals = Quartile(valTotals, 0.75)

  statisticsForDownload.median.push(Quartile(valTotals, 0.5));

  statisticsForDownload.quartile25.push(q25Totals);
  statisticsForDownload.quartile75.push(q75Totals);

  let whiskersTotal = returnLowerAndUpperWhisker(valTotals, q25Totals, q75Totals);
  
  statisticsForDownload.lowerWhisker.push(whiskersTotal[0]);
  statisticsForDownload.upperWhisker.push(whiskersTotal[1]);
  
  statisticsForDownload.stdev.push(Array_Stdev(valTotals));


  /* 
    KL Divergence:
    --------------
    We use the Kullback–Leibler divergence here to quantify the difference
    between the original probability density and the highlight probability density.
    This is used as a measure for which factor has the largest impact on a KPI.
    If the curves are nearly identical, then no matter what sample is drawn there is no impact.
  */

  let KLDivergence;
  if(typeof yDensityHighlight[0] != 'undefined'){
    // we cannot calulate KL Divergence if we open a node without a highlight (yDensityHighlight consists of 'undefined' entries)

    // Replace all values in the densityHighlight that are zero by a very small non-zero value
    // This is because KL divergence is undefined if q_i=0 and p_i>0.
    let yDensityHighlightAboveZero = [...yDensityHighlight];
    for (let i = 0; i < yDensityHighlightAboveZero.length; i++){
      if (yDensityHighlightAboveZero[i] == 0){
        yDensityHighlightAboveZero[i] = 1 * Math.pow(10, -10); // 1 * 10^-10
      }
    }

    if (yDensity.length > 1){

      // This prevents the KL Divergence from getting an array of sum zero
      // Which would let the calculation fail
      // The most common cause is an array of length 1 (with value 0)
      
      KLDivergence = calculateKLDivergence(yDensity, yDensityHighlightAboveZero);
      // console.log('yDensity plotDetails', yDensity)
      // console.log('yDensityHighlight', yDensityHighlight)
      // console.log('yDensityHighlightAboveZero plotDetails', yDensityHighlightAboveZero)
      // console.log('KLDivergence plotDetails', KLDivergence)

    }

  }


  // save array to global temp let to be able to access it and use it for highlighting
  Vue.prototype.$globalTempHighlightArray = matrix;
  // console.log('Highlight array', Vue.prototype.$globalTempHighlightArray);


  if (uidOfEmittingVueDistPreview == null){
    uidOfEmittingVueDistPreview = Vue.prototype.$globalSharedData.uidOfVueDistPreviewThatOwnsHighlight
  }

  
  Vue.prototype.$eventHub.$emit('plotData', {
    arrayMedian,
    givenName,
    width,
    margin,
    height,
    yDensity,
    x,
    density,
    densityHighlight,
    xHighlight,
    yHighlight,
    arrayQuartile25,
    arrayQuartile75,
    arrayMin,
    arrayMax,
    valTotalsMean,
    valTotalsStdev,
    valTotalsMedian,
    matrixClone,
    valTotalsQuartile25,
    valTotalsQuartile75,
    lowerBound,
    upperBound,
    idOfEmittingNode,
    uidOfEmittingVueDistPreview,
    distValuesForSelectedTimeSlice,
    matrixCloneForDownload,
    statisticsForDownload,
    shareOfDataPointsWithinRange,
    minDensityXValueIncludingAddedOnes,
    maxDensityXValueIncludingAddedOnes,
    KLDivergence,
    dataForComparisonOfDensitiesAsFormattedStrings
  });
} 

export default plotDetailPopUpGraph;
